export const CONNECTIONS = { s1: ["s2", "s3"], s2: ["s1", "s3", "s4", "s5"], s3: ["s1", "s2", "s5"], s4: ["s2", "s5"], s5: ["s2", "s3", "s4"] };
const ROMAN = { s1: "I", s2: "II", s3: "III", s4: "IV", s5: "V" };

const sysLabel = (sys, node) => {
  if (sys === "s3") return `Systeem III – ${node.system3_name || "Directie"}`;
  if (sys === "s5") return `Systeem V – ${node.system5_name || "Raad van commissarissen"}`;
  return `Systeem ${ROMAN[sys]}`;
};

export function transferTargets(node, sourceSystem, child) {
  const same = CONNECTIONS[sourceSystem].map((s) => ({ node_id: node.id, system: s, label: sysLabel(s, node) }));
  if (sourceSystem !== "s1" || !child || child.is_individual) return same;
  const lower = ["s1", "s2", "s3", "s4", "s5"].map((s) => ({ node_id: child.id, system: s, label: `${sysLabel(s, child)} in ${child.name} (niveau lager)` }));
  return [...same, ...lower];
}
